import { Component, OnInit, OnDestroy, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ModalKcsComponent } from 'src/app/_directives/modal/kcs-modal';
import { Button } from 'src/app/_models/modal/Button';
import { SpinnerService } from 'src/app/_services/SpinnerService';
import { ConfigService } from '../../_services/config.service';
import { MenuLayout, MenuLayoutService } from '../../_services/menu-layout.service';
import { CompaniesService } from '../../companies/services/companies.service';
import { PortalService } from '../../portale/_services/portal.service';
import { NotificationsService } from '../../notifications/_services/notifications.service';
import { MessagingService } from '../../messaging/_services/messaging.service';
import { ChatBrowserNotificationService } from '../../messaging/_services/chat-browser-notification.service';
import { BrandingService } from '../../_services/branding.service';
import { UserAccessibleRoutesService } from '../../dashboard/_services/user-accessible-routes.service';
import { resetAuthGuardLoadState } from '../../guards/AuthGuard';
import { MenuEditService } from '../../_services/menu-edit.service';

@Component({
	standalone: false,
	selector: 'app-header',
	templateUrl: './app-header.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./app-header.component.css'],
})
export class AppHeaderComponent implements OnInit, OnDestroy {
	@ViewChild('changeLanguageModal') changeLanguageModal!: TemplateRef<any>;

	language: string = 'it';
	modalButtons: Button[] = [
		{ label: 'Annulla', class: 'kcs-button-outlined', action: () => this.closeModal() },
		{ label: 'Salva', class: 'kcs-button', action: () => this.saveLanguage() },
	];

	unreadCount = 0;
	unreadMessagesCount = 0;
	private unreadInterval: any;
	showNotifications = true;
	// Visibilita' chat guidata dalla modalita' chat aziendale (cmp_chat_mode), non dalla config di build
	showChat = false;
	chatPanelVisible = false;

	// Posizione menu: in 'top' il menu orizzontale sta nell'header (barra unica),
	// e i selettori Azienda/User si spostano nel dropdown dell'avatar.
	menuLayout: MenuLayout = 'left';

	// Avatar cacheato nel componente: il template non deve riparsare il currentUser
	// (JSON con base64 embedded) ad ogni ciclo di change detection.
	userAvatar = '';

	private subs = new Subscription();

	currentUser: any = null;
	currentUserAdmin: any = null;
	portale: string = '';
	protalObject: any;
	select_company: any;
	//menuItems: any[] = [];
	aziende: any[] = [];
	aliasCompanies: any[] = [];
	loginAttivo = false;
	fotocaricata = false;
	foto: string = '';
	logo = '';
	menuview = false;
	active_portal_name = '';
	active_company_name = '';
	active_user_name = '';

	sel_portali: any[] = [];
	sel_portale: any;

	sel_companies: any[] = [];
	sel_company: any;
	totalCompanies = 0;

	sel_users: any[] = [];
	sel_user: any;
	totalUsers = 0;

	order = '';
	limitda = 1;

	constructor(
		private router: Router,
		private portalservice: PortalService,
		public sanitizer: DomSanitizer,
		public configService: ConfigService,
		private companiesService: CompaniesService,
		private modalService: NgbModal,
		private translate: TranslateService,
		private portalService: PortalService,
		private spinnerService: SpinnerService,
		private notificationsService: NotificationsService,
		private messagingService: MessagingService,
		private chatBrowserNotifications: ChatBrowserNotificationService,
		private menuLayoutService: MenuLayoutService,
		private brandingService: BrandingService,
		private userAccessibleRoutes: UserAccessibleRoutesService,
		public menuEdit: MenuEditService,
	) {}

	ngOnInit() {
		this.subs.add(this.menuLayoutService.layout$.subscribe((layout) => (this.menuLayout = layout)));
		this.userAvatar = this.configService.getUserAvatar();
		this.subs.add(this.configService.avatarChanged$.subscribe((avatar) => (this.userAvatar = avatar)));
		const sidebar = document.getElementById('asidebutton');
		if (sidebar) sidebar.click();
		this.currentUser = this.configService.getLocalStorageObjectJson('currentUser');
		if (this.currentUser != null) {
			this.loginAttivo = true;
			/*const portale = this.configService.getLocalStorageObjectJson('portale');
			this.loginAttivo = true;
			this.portalservice.getMenuItems(this.configService.getPortalID(), this.configService.getCompany_id()).subscribe((menuItems) => {
				this.menuItems = menuItems;
			});*/
		}
		if (localStorage.getItem('portale')) {
			this.protalObject = this.configService.getLocalStorageObjectJson('portale');
			this.portale = this.protalObject.pt_descrizione;
			this.logo = this.configService.getCompanyLogo();
			this.active_portal_name = this.getActivePortalName();
			this.getPortali();
		}

		if (localStorage.getItem('def_company_name')) {
			this.active_company_name = localStorage.getItem('def_company_name') || '';
			this.getCompany('');
		}

		const admin = localStorage.getItem('currentUserAdmin');
		if (admin) {
			this.currentUserAdmin = JSON.parse(admin);
		}
		if (localStorage.getItem('currentUser')) {
			let user = localStorage.getItem('currentUser');
			if (user) this.active_user_name = JSON.parse(user).usr_username || '';
			this.getUsers('');
		}

		this.language = this.translate.getCurrentLang() ?? this.language;

		if (this.loginAttivo) {
			const cmpId = this.configService.getCompany_id();
			if (cmpId) {
				this.companiesService.getChatMode(cmpId).subscribe({
					next: (mode) => {
						this.showChat = mode !== 'DISABLED';
						this.loadUnreadMessagesCount();
					},
					error: () => {
						// Endpoint non disponibile: fallback al default (chat visibile)
						this.showChat = true;
						this.loadUnreadMessagesCount();
					},
				});
			}

			this.loadUnreadCount();
			this.unreadInterval = setInterval(() => {
				this.loadUnreadCount();
				this.loadUnreadMessagesCount();
			}, 60000);

			// Il permesso notifiche NON viene richiesto qui: senza user-gesture il
			// prompt viene soppresso (Firefox) o degradato, e un blocco è
			// irreversibile. Si richiede solo dal toggle nelle impostazioni chat
			// (setEnabled → requestPermission), che è un'azione dell'utente.
		}
	}

	ngOnDestroy() {
		if (this.unreadInterval) {
			clearInterval(this.unreadInterval);
		}
		this.subs.unsubscribe();
	}

	loadUnreadCount() {
		if (this.loginAttivo && this.showNotifications) {
			this.notificationsService.GetUnreadCount().subscribe({
				next: (count) => (this.unreadCount = count),
				error: () => {},
			});
		}
	}

	loadUnreadMessagesCount() {
		if (this.loginAttivo && this.showChat) {
			this.messagingService.getUnreadCount().subscribe({
				next: (count) => {
					this.unreadMessagesCount = count;
					// Sempre, non solo quando il totale cresce: se nello stesso poll una
					// conversazione cala e un'altra sale il totale non cambia, ma il
					// confronto per-conversazione dentro notifyNewChatMessages sì.
					this.notifyNewChatMessages();
				},
				error: () => {},
			});
		}
	}

	// Notifiche desktop del browser sui nuovi messaggi chat (per conversazione, escluse le silenziate)
	private lastConvUnread = new Map<number, number>();
	private chatNotifyInitialized = false;

	private notifyNewChatMessages(): void {
		// La fetch della lista serve solo a mostrare notifiche desktop: se sono
		// disattivate o senza permesso non ha senso il traffico HTTP extra ogni 60s.
		if (!this.chatBrowserNotifications.canNotify()) {
			this.lastConvUnread.clear();
			this.chatNotifyInitialized = false;
			return;
		}
		this.messagingService.getConversations(true).subscribe({
			next: (convs) => {
				// Niente notifica se l'utente sta già guardando la chat: drawer aperto
				// oppure pagina /messaging a schermo intero (con finestra in primo piano)
				const viewingChat = this.chatPanelVisible || this.router.url.startsWith('/messaging');
				for (const c of convs || []) {
					const prevUnread = this.lastConvUnread.get(c.conv_id) ?? 0;
					const unread = c.unread_count || 0;
					const shouldNotify = this.chatNotifyInitialized && unread > prevUnread && !c.muted && (document.hidden || !viewingChat);
					if (shouldNotify) {
						const name = c.other_company_name || [c.other_firstname, c.other_lastname].filter(Boolean).join(' ') || 'Chat';
						this.chatBrowserNotifications.notify(name, this.configService.getTranslate('Ti ha scritto un messaggio'), () => {
							this.router.navigate(['/messaging/lista'], { queryParams: { conv: c.conv_id } });
						});
					}
					this.lastConvUnread.set(c.conv_id, unread);
				}
				this.chatNotifyInitialized = true;
			},
			error: () => {},
		});
	}

	ngAfterViewInit() {
		if (localStorage.getItem('portale')) {
			//Abilito la selezione portale nel header
			if (this.sel_portali.length > 1) {
				document.getElementById('portal_selection')?.classList.add('selectable');
			}
		}
		if (localStorage.getItem('def_company_name')) {
			if (this.totalCompanies > 1) {
				document.getElementById('company_selection')?.classList.add('selectable');
			}
		}
	}

	getAliasCompanies(pt_id: number) {
		this.portalservice.getAliasCompanies(pt_id).subscribe((res: any) => {
			if (res) {
				this.aliasCompanies = res;

				for (let i = 0; i < this.aziende.length; i++) {
					for (let j = 0; j < this.aliasCompanies.length; j++) {
						if (this.aliasCompanies[j] === this.aziende[i].id) {
							this.aziende[i].cmp_isChecked = true;
						}
					}
				}
				this.aziende = this.aziende.filter((x) => x.cmp_isChecked);
				if (this.aziende) {
					if (this.aziende.length == 1) {
						//TODO this.default_company_name = this.aziende[0].name;
					}
				}
			}
		});
	}
	cambioLista() {
		if (this.menuview) {
			this.menuview = false;
			let sidebar = document.getElementById('sidebar1');
			if (sidebar) {
				sidebar.removeAttribute('hidden');
				sidebar.setAttribute('visible', '');
				this.modifySidebarCSS('16rem');
			}

			localStorage.setItem('menuview', 'false');
		} else {
			this.menuview = true;
			let sidebar = document.getElementById('sidebar1');
			if (sidebar) {
				sidebar.removeAttribute('visible');
				sidebar.setAttribute('hidden', '');
				this.modifySidebarCSS('0rem');
			}
			localStorage.setItem('menuview', 'true');
		}
	}

	modifySidebarCSS(value: string) {
		// Trova tutti i fogli di stile caricati
		const styleSheets = Array.from(document.styleSheets) as CSSStyleSheet[];

		for (const sheet of styleSheets) {
			try {
				// Trova le regole CSS
				const rules = Array.from(sheet.cssRules || sheet.rules);

				for (const rule of rules) {
					// Cerca la regola @media con il selettore specificato
					if (rule instanceof CSSMediaRule && rule.conditionText === '(min-width: 992px)') {
						const sidebarRule = Array.from(rule.cssRules).find((r) => r.cssText.includes('.sidebar:not(.hide)'));

						if (sidebarRule && sidebarRule instanceof CSSStyleRule) {
							// Modifica la proprietà --cui-sidebar-occupy-start
							sidebarRule.style.setProperty('--cui-sidebar-occupy-start', value);
							return; // Interrompi il ciclo dopo aver modificato
						}
					}
				}
			} catch (e) {
				console.error("Errore nell'accesso al foglio di stile", e);
			}
		}
	}

	gotoLogin(doLogout?: boolean) {
		if (doLogout) {
			const cmpMemento = this.configService.getCompanyMemento();
			localStorage.removeItem('login');
			localStorage.clear();
			sessionStorage.clear();
			// Il logout è una navigazione SPA (nessun reload): i singleton root e lo
			// stato applicato al <html> sopravvivono, quindi vanno azzerati a mano,
			// altrimenti l'utente/azienda successivo eredita menu, permessi,
			// layout e branding del precedente (privilege leak + UI stantia).
			resetAuthGuardLoadState();
			this.portalService.invalidateMenuCache();
			this.userAccessibleRoutes.reset();
			this.menuLayoutService.reset();
			this.brandingService.clear();
			this.configService.restoreCompanyMemento(cmpMemento);
			this.loginAttivo = false;
			this.fotocaricata = false;
			console.log('gotoLogin doLogout login_due_fattori');
			this.router.navigate(['/login_due_fattori']);
		} else {
			localStorage.removeItem('portale');
			this.activatePortale();
			console.log('gotoLogin else login_due_fattori');
			this.router.navigate(['/login_due_fattori']);
		}
	}

	navigateTo(url: any) {
		this.router.navigate(['/' + url]);
	}

	activatePortale() {
		this.portalservice.activateSceltaPortale();
	}

	goToProfile() {
		this.router.navigate(['/profile']);
	}

	/**
	 * Nuova azienda: porta al percorso guidato, non alla sola anagrafica.
	 *
	 * L'anagrafica da sola produce un'azienda che esiste ma non funziona: niente
	 * servizi, niente dati di base (le combo dei form restano vuote e tre di esse
	 * non hanno alcuna interfaccia per riempirle), nessun ruolo e nessun utente.
	 * Il percorso guidato fa tutta la catena; l'id 0 vuol dire "azienda nuova".
	 */
	nuovaAzienda() {
		this.router.navigate(['/portale/onboarding-azienda', 0]);
	}

	changeLanguage() {
		const modalRef = this.modalService.open(ModalKcsComponent, { ariaLabelledBy: 'modal-title' });
		modalRef.componentInstance.openModal('Seleziona Lingua', '', this.modalButtons, 'primary', this.changeLanguageModal);
		modalRef.result.then(
			() => {
				console.log('lang se');

				this.closeModal();
			},
			() => {
				console.log('lang ko');
				this.closeModal();
			},
		);
	}

	saveLanguage() {
		this.configService.setLanguage(this.language);
		this.closeModal();
		window.location.reload();
	}

	closeModal() {
		this.modalService.dismissAll();
	}

	changePortal() {
		this.gotoLogin(false);
	}

	signOut() {
		this.gotoLogin(true);
	}

	getActivePortalName(): string {
		let portale_json = localStorage.getItem('portale');
		try {
			if (portale_json) {
				let portale_json_parsed = JSON.parse(portale_json);
				return portale_json_parsed.pt_descrizione;
			}
		} catch (error) {
			console.error('Cannot get portal pt_descrizione from portale_json_parsed');
		}
		return '';
	}

	getActiveCompanyName(): string {
		let company_name = localStorage.getItem('def_company_name');
		if (company_name) {
			return company_name;
		}
		return '';
	}

	getPortali() {
		if (this.configService.getUser()) {
			this.portalService.getPortaliUser(this.configService.getUser().usr_id).subscribe((res: any) => {
				this.sel_portali = res;
			});
		}
	}

	getCompany(cerca: string) {
		this.companiesService.GetListCompanies(-1, cerca, this.order, 50, this.limitda).subscribe((res: any) => {
			this.sel_companies = res;
			if (!cerca) {
				this.totalCompanies = res.length;
			}
		});
	}

	getUsers(cerca: string) {
		this.portalService.GetListUtenti(cerca, this.order, this.limitda, 50, this.configService.getCompany_id()).subscribe((res: any) => {
			this.sel_users = res;
			if (!cerca) {
				this.totalUsers = res.length;
			}
		});
	}

	selectPortale(portale?: any) {
		this.spinnerService.show('app');

		let tmp_portale = this.sel_portale;
		if (portale) {
			tmp_portale = portale;
		}

		tmp_portale.total_rows = this.sel_portali.length;

		this.portalService.setPortale(tmp_portale.pt_id).subscribe((res: any) => {
			localStorage.setItem('portale', JSON.stringify(tmp_portale));
			let currentUser = this.configService.getUser();
			currentUser.token = res.res;
			localStorage.setItem('currentUser', JSON.stringify(currentUser));
			this.router.navigate(['/']);
			setTimeout(() => {
				window.location.reload();
			}, 100);
		});
	}

	selectCompany() {
		this.spinnerService.show('app');
		//Set cpompany Name
		localStorage.setItem('def_company_name', this.sel_company.name);

		this.configService.setCompany_id(this.sel_company.id);
		// Il logo non viaggia piu' nelle liste: al reload l'AuthGuard lo scarica
		// via companies/logo/{cmp_id} e lo mette in cache per azienda.

		// gruppo funzionale: va salvato PRIMA del reload, pilota le traduzioni per gruppo
		this.companiesService.GetCompanyGroup(this.sel_company.id).subscribe({
			next: (group: string) => {
				this.configService.setCompanyGroup(group);
				this.finishSelectCompany();
			},
			error: () => {
				this.configService.setCompanyGroup('standard');
				this.finishSelectCompany();
			},
		});
	}

	private finishSelectCompany() {
		this.router.navigate(['/']);
		setTimeout(() => {
			window.location.reload();
		}, 100);
	}
	selectUser() {
		//chiamo per avere l'utente come in login
		//prendo il currentUser e lo metto in currentUserAdmin prendo il risultato della chiamata e lo metto come current user

		// L'impersonificazione deve essere una situazione veritiera: l'utente va impersonato
		// su un portale a cui e' davvero associato. I portali si leggono PRIMA dello scambio
		// di utenza, cioe' ancora con il token dell'admin.
		this.portalService.getPortaliUser(this.sel_user.usr_id).subscribe((res_portali: any) => {
			const portaliUtente: any[] = res_portali || [];
			if (portaliUtente.length === 0) {
				this.configService.openErrorNotify(this.configService.getTranslate('Utente non associato a nessun portale'));
				this.sel_user = null;
				return;
			}

			const portaleCorrente = this.configService.getLocalStorageObjectJson('portale');
			// Se l'utente e' associato anche al portale corrente si resta li', altrimenti si
			// passa sul suo portale: impersonarlo su un portale che non e' suo non ha senso.
			const portaleTarget = portaliUtente.find((p) => portaleCorrente && p.pt_id === portaleCorrente.pt_id) || portaliUtente[0];

			this.portalService.loginAsUser(this.sel_user.usr_id).subscribe((response: any) => {
				if (!response || !response.usr_username || !response.token) {
					this.configService.openErrorNotify(this.configService.getTranslate('Impossibile impersonare l utente'));
					this.sel_user = null;
					return;
				}

				// Salva l'utente corrente e il suo portale come admin (se non è già un impersonificato)
				const currentUser = this.configService.getUser();
				if (currentUser && !localStorage.getItem('currentUserAdmin')) {
					localStorage.setItem('currentUserAdmin', JSON.stringify(currentUser));
					if (portaleCorrente) {
						localStorage.setItem('portaleAdmin', JSON.stringify(portaleCorrente));
					}
					this.currentUserAdmin = currentUser;
				}

				const impersonatedUser = response;
				impersonatedUser.token = response.token;

				// Aggiorna currentUser
				localStorage.setItem('currentUser', JSON.stringify(impersonatedUser));

				// Aggiorna nome utente attivo
				this.active_user_name = impersonatedUser.usr_username;

				// Il token dell'impersonato nasce senza portale: gli si applica quello scelto,
				// esattamente come fa il login dopo la scelta del portale (confermaPortale).
				this.portalService.setPortale(portaleTarget.pt_id).subscribe((res: any) => {
					localStorage.setItem('portale', JSON.stringify(portaleTarget));
					const utente = this.configService.getUser();
					utente.token = res.res;
					localStorage.setItem('currentUser', JSON.stringify(utente));
					this.router.navigate(['/']);
					setTimeout(() => {
						window.location.reload();
					}, 100);
				});
			});
		});
	}

	restoreAdmin() {
		const adminUser = localStorage.getItem('currentUserAdmin');
		if (adminUser) {
			const parsedAdmin = JSON.parse(adminUser);
			localStorage.setItem('currentUser', JSON.stringify(parsedAdmin));
			localStorage.removeItem('currentUserAdmin');

			// Il token dell'admin porta con se' il suo portale: va rimesso anche il portale
			// salvato all'inizio dell'impersonificazione, altrimenti l'header resterebbe su
			// quello dell'utente impersonato.
			const portaleAdmin = localStorage.getItem('portaleAdmin');
			if (portaleAdmin) {
				localStorage.setItem('portale', portaleAdmin);
				localStorage.removeItem('portaleAdmin');
			}

			this.currentUserAdmin = null;
			this.active_user_name = parsedAdmin.usr_username;

			this.spinnerService.hide('app');
			this.router.navigate(['/']);
			setTimeout(() => {
				window.location.reload();
			}, 100);
		}
	}

	onComapnyFilterChange(event: any) {
		const filterValue = event.filter; // Ottieni il valore del filtro
		if (filterValue && filterValue.length >= 3) {
			this.getCompany(filterValue);
		}
	}

	onUserFilterChange(event: any) {
		const filterValue = event.filter; // Ottieni il valore del filtro
		if (filterValue && filterValue.length >= 3) {
			this.getUsers(filterValue);
		}
	}
}
